module.exports = __webpack_public_path__ + "img/music_3.6f8e1783.png";